import { render, staticRenderFns } from "./AllegacyForms.vue?vue&type=template&id=633bb5c0&scoped=true"
import script from "./AllegacyForms.vue?vue&type=script&lang=ts"
export * from "./AllegacyForms.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633bb5c0",
  null
  
)

export default component.exports